import { usePriceFormat } from '@/hooks/usePriceFormat'
import { Grid } from '@chakra-ui/react'
import { useTranslationsContext } from 'BrokerTsLib/src/context/TranslationsContext'
import type { Statistics } from 'BrokerTsLib/src/dtos'
import { StatCard } from './StatCard'
import { StatChangeValue } from './StatChangeValue'
import { StatValue } from './StatValue'

interface MainStatsGridProps {
  stats: Statistics;
  adjustedPreviousStats: Statistics;
  isLoadingStats: boolean;
  adjustedPreviousTimeRangeLabel: string;
  previousTimeRangeLabel: string;
}

export const MainStatsGrid = ({
  stats,
  adjustedPreviousStats,
  isLoadingStats,
  adjustedPreviousTimeRangeLabel,
  previousTimeRangeLabel
}: MainStatsGridProps) => {
  const { translate } = useTranslationsContext()
  const { priceFormat, currency, zeroPriceLabel } = usePriceFormat()

  return (
    <Grid
      sx={{
        alignContent: 'stretch',
        gridTemplateColumns: { base: '1fr 1fr', lg: '1fr' },
        gap: 4,
      }}
    >
      <StatCard label={translate('ui.Dashboard.Stats.Premium', 'Předepsané pojistné')}>
        <StatValue isLoading={isLoadingStats} fontSize='4xl'>
          {priceFormat(stats.predepanePojistne, zeroPriceLabel)}
        </StatValue>
        <StatChangeValue
          isLoading={isLoadingStats}
          value={stats.predepanePojistne ?? 0}
          baselineValue={adjustedPreviousStats.predepanePojistne ?? 0}
          baselineValueLabel={adjustedPreviousTimeRangeLabel}
          absoluteUnit={currency?.unit}
        />
      </StatCard>

      <StatCard label={translate('ui.Dashboard.Stats.AveragePremium', 'Průměrná výše pojistného')}>
        <StatValue isLoading={isLoadingStats} fontSize='2xl'>
          {priceFormat(stats.predepanePojistne / stats.pocetSmluv, zeroPriceLabel)}
        </StatValue>
        <StatChangeValue
          isLoading={isLoadingStats}
          value={stats.predepanePojistne / stats.pocetSmluv}
          baselineValue={adjustedPreviousStats.predepanePojistne / adjustedPreviousStats.pocetSmluv}
          baselineValueLabel={previousTimeRangeLabel}
          absoluteUnit={currency?.unit}
        />
      </StatCard>
    </Grid>
  )
}
